import styled, { css, keyframes } from 'styled-components';

const fadeSlideUp = keyframes`
    from {
        opacity: 0;
        transform: translateY(12px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
`;

const motionSafe = (styles: ReturnType<typeof css>) => css`
    @media (prefers-reduced-motion: no-preference) {
        ${styles}
    }
`;

export const Wrapper = styled.div`
    display: flex;
    position: relative;
    flex-direction: column;
    padding: 20px;
    height: 100vh;
    max-width: 400px;
    margin: 0 auto;
    box-sizing: border-box;

    @media screen and (max-width: 769px) {
        max-width: 700px;
        margin: 0;
    }
`;

export const Content = styled.div`
    display: flex;
    flex-direction: column;
    flex: 1;
    min-height: 0;
    ${motionSafe(css`
        animation: ${fadeSlideUp} 0.35s ease-out;
    `)}
`;

export const Section = styled.div<{ $index?: number }>`
    width: 100%;

    ${({ $index }) =>
        typeof $index === 'number' &&
        motionSafe(css`
            /* "backwards" (not "both") on purpose: "both" would leave a
               non-none transform on this element permanently after the
               animation ends, which creates a new containing block for any
               position:fixed descendant (e.g. the transaction details
               modal), pinning it near the top of this section instead of
               centering in the real viewport. */
            animation: ${fadeSlideUp} 0.35s ease-out backwards;
            animation-delay: ${Math.min($index, 4) * 0.06}s;
        `)}
`;

export const TransactionSearchFlex = styled.div`
    margin-top: 20px;
    width: 100%;
`;
